import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import cn from "classnames";
import { useMeCore } from "../../../cores/me";
import { PanelWembii } from "../PanelWembii";
import { useGlobalCore } from "../../../cores/globals";
import SidebarNavigation from "./SidebarNavigation";
import SidebarAdminRoutes from "./SidebarAdminRoutes";
import SidebarResellerRoutes from "./SidebarResellerRoutes";
import SidebarUserRoutes from "./SidebarUserRoutes";

const Sidebar = () => {
  const { isAdmin, isReseller } = useMeCore();
  const { collapseSideBar, setOpenSideBar } = useGlobalCore();

  return (
    <PanelWembii
      className={cn("h-100 wembii-sidebar", {
        sidebarExpanded: !collapseSideBar,
        sidebarCollaped: collapseSideBar,
      })}
    >
      <div className="p-3 flex-grow-1 sidebar-inner-scroll">
        <div className="d-flex d-lg-none justify-content-end mb-2">
          <button
            type="button"
            className="border-0 rounded d-flex align-items-center justify-content-center p-2 sidebar-mobile-close sidebar-mobile-close-btn"
            style={{
              minWidth: 44,
              minHeight: 44,
            }}
            onClick={() => setOpenSideBar(false)}
            aria-label="Cerrar menú"
          >
            <FontAwesomeIcon
              icon={["fas", "times"]}
              className="sidebar-mobile-close-icon"
              size="lg"
            />
          </button>
        </div>
        <SidebarNavigation />

        {!isAdmin && <SidebarUserRoutes collapseSideBar={collapseSideBar} />}

        {isReseller && (
          <SidebarResellerRoutes collapseSideBar={collapseSideBar} />
        )}
        {isAdmin && <SidebarAdminRoutes collapseSideBar={collapseSideBar} />}
      </div>
    </PanelWembii>
  );
};

export default React.memo(Sidebar);
